import { ReactNode } from 'react'
import { Header } from './Header'
import { Footer } from './Footer'
import styles from './PageLayout.module.css'

interface PageLayoutProps {
  children: ReactNode
}

export function PageLayout({ children }: PageLayoutProps) {
  return (
    <div className={styles.layout}>
      <Header />
      <main id="main-content" className={styles.main}>
        {children}
      </main>
      <Footer />
    </div>
  )
}


